import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import TickIcon from '../../../images/icon_green_tick.svg'

export const Container = styled.div`
  background: ${themeStyles.colors.darkGreys[5].main};
  color: ${themeStyles.colors.white.main};
  padding: 15px;
  min-width: 260px;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}

  ${({ isSmall }) =>
    isSmall &&
    css`
      height: 100%;
      aspect-ratio: 390 / 107;
      display: flex;
      flex-direction: column;
      justify-content: center;
    `}


  ${themeMedia.tablet`
    min-width: 350px;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > p:first-child {
    margin-bottom: 0.5em;
  }
`

export const StyledSubtitle = styled.p`
  font-size: 12px;
  margin: 0;

  ${themeMedia.desktop`
  font-size: 14px;
  `}
`

export const StyledAmountText = styled.p`
  color: ${themeStyles.colors.products.liveCasino.main};
  text-align: left;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 14px;
  font-size: 17px;

  ${({ cashbackType }) =>
    cashbackType === 'BONUS' &&
    css`
      color: ${themeStyles.colors.accentColors.secondary.main};
    `}

  ${themeMedia.desktop`
  font-size: 21px;
  `}
`

export const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  ${themeMedia.maxTablet`
    width: 50px;
    height: 50px;
  `}

  img {
    width: 100%;
    height: 100%;

    ${({ $type }) =>
      $type === 'small' &&
      css`
        filter: grayscale(100%) brightness(0.9);
      `}
  }
`
export const ClaimedTextContainer = styled.div`
  background-color: ${themeStyles.colors.darkGreys[3].main};
  padding: 4px 5px 4px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: ${themeStyles.colors.white.main};
  font-size: 13px;

  position: relative;

  p {
    margin: 0;
    font-weight: 700;
    margin-left: 2px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 48%;
    top: calc(50% - 8px);
    width: 14px;
    height: 14px;
    background-image: url(${TickIcon});
    background-size: contain;
    background-repeat: no-repeat;
  }
`
